module.exports = __webpack_public_path__ + "static/media/about_01.1d330c98.jpg";